let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9U3Mo")).then(() => parcelRequire('1wxug'));